// extracted by mini-css-extract-plugin
export var address = "store_detail-module--address--c171d";
export var brand_head = "store_detail-module--brand_head--60cea";
export var col = "store_detail-module--col--29d31";
export var cols = "store_detail-module--cols--e8782";
export var desc = "store_detail-module--desc--e3328";
export var desk_vid = "store_detail-module--desk_vid--4770a";
export var full_image = "store_detail-module--full_image--12699";
export var images = "store_detail-module--images--7f7da";
export var img = "store_detail-module--img--d5833";
export var info = "store_detail-module--info--5fc36";
export var map = "store_detail-module--map--86747";
export var map_box = "store_detail-module--map_box--b2b3a";
export var map_link = "store_detail-module--map_link--bf242";
export var mapwr = "store_detail-module--mapwr--074f0";
export var mob_vid = "store_detail-module--mob_vid--bf14f";
export var name = "store_detail-module--name--c2e25";
export var shop = "store_detail-module--shop--0a875";
export var store = "store_detail-module--store--d5b86";
export var storeDetailMap__name = "store_detail-module--store-detail-map__name--d95d4";
export var store_carou = "store_detail-module--store_carou--0cafc";
export var store_imgcol = "store_detail-module--store_imgcol--16913";
export var store_imgcols = "store_detail-module--store_imgcols--b5d92";
export var svgRounded_arrow = "store_detail-module--svg-rounded_arrow--1a284";
export var title = "store_detail-module--title--a16a2";